export default __webpack_public_path__ + "static/media/ms_logo.4a88fcf6.webp";